
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmallAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.637 8.587C5.637 4.957 8.517 2 11.99 2s6.353 2.957 6.374 6.587c0 2.196-1.059 4.109-2.541 5.217v1.63c0 .457-.381.827-.826.87l-5.824.479H9.09a.857.857 0 0 1-.593-.24c-.17-.152-.318-.39-.318-.63v-2.13c-1.694-1.196-2.541-2.979-2.541-5.196zm8.47 4.717c0-.304.149-.608.424-.76 1.334-.74 2.096-2.218 2.118-3.957 0-2.674-2.097-4.848-4.66-4.848-2.562 0-4.658 2.174-4.637 4.848 0 1.783.678 3.087 2.139 3.957a.899.899 0 0 1 .381.76v1.674l4.235-.348v-1.326z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.53 12.543c-.275.152-.423.456-.423.76v1.327l-4.235.347v-1.674a.899.899 0 0 0-.381-.76c-1.462-.87-2.14-2.174-2.14-3.957-.02-2.674 2.076-4.848 4.638-4.848 2.563 0 4.66 2.174 4.66 4.848-.022 1.74-.784 3.217-2.118 3.957z",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.934 19.086-5.782.435H9.09c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .783-.935l5.781-.435a.835.835 0 0 1 .911.805.867.867 0 0 1-.783.934zm-1.844 2.74L11.017 22h-.064c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .784-.935l2.096-.174a.842.842 0 0 1 .89.804.867.867 0 0 1-.784.935zm2.265-13.26c-.042.391-.36.696-.74.696h-.064a.75.75 0 0 1-.657-.826c.127-1.24-.931-1.696-1.059-1.74a.79.79 0 0 1-.444-.978c.127-.391.55-.608.931-.456.784.282 2.224 1.348 2.034 3.304z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"72\" height=\"72\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.637 8.587C5.637 4.957 8.517 2 11.99 2s6.353 2.957 6.374 6.587c0 2.196-1.059 4.109-2.541 5.217v1.63c0 .457-.381.827-.826.87l-5.824.479H9.09a.857.857 0 0 1-.593-.24c-.17-.152-.318-.39-.318-.63v-2.13c-1.694-1.196-2.541-2.979-2.541-5.196zm8.47 4.717c0-.304.149-.608.424-.76 1.334-.74 2.096-2.218 2.118-3.957 0-2.674-2.097-4.848-4.66-4.848-2.562 0-4.658 2.174-4.637 4.848 0 1.783.678 3.087 2.139 3.957a.899.899 0 0 1 .381.76v1.674l4.235-.348v-1.326z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M14.53 12.543c-.275.152-.423.456-.423.76v1.327l-4.235.347v-1.674a.899.899 0 0 0-.381-.76c-1.462-.87-2.14-2.174-2.14-3.957-.02-2.674 2.076-4.848 4.638-4.848 2.563 0 4.66 2.174 4.66 4.848-.022 1.74-.784 3.217-2.118 3.957z\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n    <path d=\"m14.934 19.086-5.782.435H9.09c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .783-.935l5.781-.435a.835.835 0 0 1 .911.805.867.867 0 0 1-.783.934zM13.09 21.826 11.017 22h-.064c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .784-.935l2.096-.174a.842.842 0 0 1 .89.804.867.867 0 0 1-.784.935zM15.355 8.566c-.042.391-.36.696-.74.696h-.064a.75.75 0 0 1-.657-.826c.127-1.24-.931-1.696-1.059-1.74a.79.79 0 0 1-.444-.978c.127-.391.55-.608.931-.456.784.282 2.224 1.348 2.034 3.304z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/small-alert.eea9ef94e9c2741e312f878e9e28abac.svg"),
        {
          React: SvgSmallAlert,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      